import { initReactQueryAuth } from 'react-query-auth';
import { Spinner } from '@primer/react';
import {
  getUser,
  register,
  UserResponse,
  RegisterCredentialsDTO,
  AuthUser,
  logoutUser,
} from '@/features/auth';
import storage from '@/utils/storage';
import { getFlowscaleUser } from '@/features/users';
import { getTeams } from '@/features/teams';

async function handleUserResponse(tokens: any) {
  if (tokens) {
    storage.setAccessToken(tokens?.access_token);
    storage.setRefreshToken(tokens?.refresh_token);
    storage.setIdToken(tokens?.id_token);
  }

  if (tokens?.access_token && storage.getTeam() === null) {
    const team = await getTeams();
    if (team[0]?._id) {
      storage.setTeam(team[0]);
    }
  }
  return tokens;
}

async function loadUser(): Promise<AuthUser | null> {
  const token = storage.getAccessToken();
  if (token) {
    try {
      const user = await getFlowscaleUser();
      return user;
    } catch (error) {
      storage.clearAllTokens();
      return null;
    }
  }
  return null;
}

async function loginFn(tokens: any) {
  if (tokens) {
    // Handle direct token response from Google login
    const user = await handleUserResponse(tokens);
    return user;
  }
}

async function registerFn(data: RegisterCredentialsDTO) {
  const response = await register(data);
  const user = await handleUserResponse(response);
  return user;
}

async function logoutFn() {
  try {
    await logoutUser().finally(() => {
      storage.clearAllTokens();
      window.location.assign(window.location.origin as unknown as string);
    });
  } catch (error) {
    // Continue with logout even if API call fails
    console.error('Logout API call failed:', error);
  }
}

const authConfig = {
  loadUser,
  loginFn,
  registerFn,
  logoutFn,
  LoaderComponent() {
    return (
      <div className="w-screen h-screen flex justify-center items-center">
        <Spinner size="large" />
      </div>
    );
  },
};

export const { AuthProvider, useAuth } = initReactQueryAuth<
  AuthUser | null,
  unknown,
  { google_access_token?: string },
  RegisterCredentialsDTO
>(authConfig);
